var _g, _circle, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_497_13004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 17.6329V22.2728",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8477 14.8489V14.8607",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5586 22.2728V17.6329",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2705 22.2728V19.4889C22.2705 18.9966 22.075 18.5246 21.7269 18.1765C21.3789 17.8284 20.9068 17.6329 20.4146 17.6329C19.9223 17.6329 19.4503 17.8284 19.1022 18.1765C18.7541 18.5246 18.5586 18.9966 18.5586 19.4889",
    stroke: "white",
    strokeWidth: 1.85597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.334 28.7504V14.6671C10.334 13.8051 10.6764 12.9785 11.2859 12.369C11.8954 11.7595 12.722 11.4171 13.584 11.4171H24.4173C25.2793 11.4171 26.1059 11.7595 26.7154 12.369C27.3249 12.9785 27.6673 13.8051 27.6673 14.6671V21.1671C27.6673 22.029 27.3249 22.8557 26.7154 23.4652C26.1059 24.0747 25.2793 24.4171 24.4173 24.4171H14.6673L10.334 28.7504Z",
    fill: "#37994F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.668 15.7501H23.3346",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.668 20.0831H21.168",
    stroke: "white",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5597,
    cy: 18.5597,
    r: 17.8637,
    stroke: "#37994F",
    strokeWidth: 1.39198
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_497_13004"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2716,
    height: 22.2716,
    fill: "white",
    transform: "translate(7.42383 7.42392)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.6d93d53ad16f5db85dba3d7ee0aee8a1.svg";
export { ForwardRef as ReactComponent };